// useCandidatoListagem.js
import { useLatestAsyncRequest } from '@spark/ui-components/hooks/useLatestAsyncRequest';
import { useState, useEffect, useCallback } from 'react';
import { getCandidatos } from '@spark/services/recrutamento-rh';

function mapUiToApi(ui = {}) {
  const out = {};

  if (ui.search && ui.search.trim()) out.search = ui.search.trim();
  if (ui.IdVaga !== '' && ui.IdVaga !== undefined && ui.IdVaga !== null) out.IdVaga = ui.IdVaga;
  if (ui.TituloVaga !== '' && ui.TituloVaga !== undefined && ui.TituloVaga !== null) out.TituloVaga = ui.TituloVaga;
  if (ui.Nome && ui.Nome.trim()) out.Nome = ui.Nome.trim();
  if (ui.Sobrenome && ui.Sobrenome.trim()) out.Sobrenome = ui.Sobrenome.trim();
  if (ui.CPF && ui.CPF.trim()) out.CPF = ui.CPF.trim();
  if (ui.Email && ui.Email.trim()) out.Email = ui.Email.trim();
  if (ui.NumeroTelefone && ui.NumeroTelefone.trim()) out.NumeroTelefone = ui.NumeroTelefone.trim();
  if (ui.Escolaridade && ui.Escolaridade !== '') out.Escolaridade = ui.Escolaridade;
  if (ui.EstadoLocalizacao && ui.EstadoLocalizacao.trim()) out.EstadoLocalizacao = ui.EstadoLocalizacao.trim();
  if (ui.CidadeLocalizacao && ui.CidadeLocalizacao.trim()) out.CidadeLocalizacao = ui.CidadeLocalizacao.trim();
  if (ui.BairroLocalizacao && ui.BairroLocalizacao.trim()) out.BairroLocalizacao = ui.BairroLocalizacao.trim();
  if (ui.RuaLocalizacao && ui.RuaLocalizacao.trim()) out.RuaLocalizacao = ui.RuaLocalizacao.trim();
  if (ui.CEPLocalizacao && ui.CEPLocalizacao.trim()) out.CEPLocalizacao = ui.CEPLocalizacao.trim();
  if (ui.NumeroLocalizacao && ui.NumeroLocalizacao.trim()) out.NumeroLocalizacao = ui.NumeroLocalizacao.trim();
  if (ui.somenteComCNH !== '' && ui.somenteComCNH !== undefined && ui.somenteComCNH !== null) out.somenteComCNH = ui.somenteComCNH; 
  if (ui.NumeroCNH && ui.NumeroCNH.trim()) out.NumeroCNH = ui.NumeroCNH.trim();
  if (ui.CategoriaCNH && ui.CategoriaCNH !== '') out.CategoriaCNH = ui.CategoriaCNH;
  if (ui.validadeCnhInicio) out.validadeCnhInicio = ui.validadeCnhInicio;
  if (ui.validadeCnhFim) out.validadeCnhFim = ui.validadeCnhFim;
  if (ui.somenteComCurriculo !== '' && ui.somenteComCurriculo !== undefined && ui.somenteComCurriculo !== null) out.somenteComCurriculo = ui.somenteComCurriculo;
  if (ui.dataCriadoInicio) out.dataCriadoInicio = ui.dataCriadoInicio;
  if (ui.dataCriadoFim) out.dataCriadoFim = ui.dataCriadoFim;
  if (ui.PIS && ui.PIS.trim()) out.PIS = ui.PIS.trim();
  if (ui.incluirDeletados !== '' && ui.incluirDeletados !== undefined && ui.incluirDeletados !== null)out.incluirDeletados = ui.incluirDeletados;
  if (ui.sortBy && ui.sortBy !== '') out.sortBy = ui.sortBy;
  if (ui.sortDir && ui.sortDir !== '') out.sortDir = ui.sortDir;

  return out;
}

export const useCandidatoListagem = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterLoading, setFilterLoading] = useState(false);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [quantidadePorPagina, setQuantidadePorPagina] = useState(20);

  const [filtrosUI, setFiltrosUI] = useState({
    search: '',
    IdVaga: '',
    TituloVaga: '',
    Nome: '',
    Sobrenome: '',
    CPF: '',
    Email: '',
    NumeroTelefone: '',
    Escolaridade: '',
    EstadoLocalizacao: '',
    CidadeLocalizacao: '',
    BairroLocalizacao: '',
    RuaLocalizacao: '',
    CEPLocalizacao: '',
    NumeroLocalizacao: '',
    somenteComCNH: '',
    NumeroCNH: '',
    CategoriaCNH: '',
    validadeCnhInicio: '',
    validadeCnhFim: '',
    somenteComCurriculo: '',
    dataCriadoInicio: '',
    dataCriadoFim: '',
    PIS: '',
    incluirDeletados: '',
    sortBy: '',
    sortDir: '',
  });

  const { beginRequest, isCurrentRequest, isMounted } = useLatestAsyncRequest();

  const fetchData = useCallback(async (pagina = paginaAtual, limite = quantidadePorPagina, ui = filtrosUI) => {
    if (!isMounted()) return;

    const requestId = beginRequest();
    try {
      setLoading(true);

      const apiFilters = mapUiToApi(ui);
      const res = await getCandidatos(apiFilters, pagina, limite);

      if (!isCurrentRequest(requestId)) return;

      const registros = res?.registros ?? [];
      const total = res?.totalRegistros ?? 0;
      const dados = registros.map((v) => ({
        id: v.id ?? v.Id ?? v.ID,
        Nome: v.Nome || '',
        Sobrenome: v.Sobrenome || '',
        CPF: v.CPF || '',
        Email: v.Email || '',
        NumeroTelefone: v.NumeroTelefone || '',
        Escolaridade: v.Escolaridade || '',
        CidadeLocalizacao: v.CidadeLocalizacao || '',
        EstadoLocalizacao: v.EstadoLocalizacao || '',
        IdVaga: v.IdVaga ?? '',
        CategoriaCNH: v.CategoriaCNH || '',
        NumeroCNH: v.NumeroCNH || '',
        ValidadeCNH: v.ValidadeCNH || '',
        ImgCurriculo: v.ImgCurriculo || null,
        DataCriado: v.DataCriado || v.dataCriado || '',
        Visualizado: v.Visualizado || v.Visualizado || '',
        TituloVaga: v.TituloVaga || v.TituloVaga || '',
      }));

      setData(dados);
      setTotalRegistros(Number(total) || 0);
    } catch (e) {
      if (!isCurrentRequest(requestId)) return;
      setData([]);
      setTotalRegistros(0);
    } finally {
      if (isCurrentRequest(requestId)) {
        setLoading(false);
        setFilterLoading(false);
      }
    }
  }, [beginRequest, filtrosUI, isCurrentRequest, isMounted, paginaAtual, quantidadePorPagina]);

  useEffect(() => {
    fetchData(paginaAtual, quantidadePorPagina, filtrosUI);
  }, [fetchData]);

  const handleFilterApply = useCallback((newUiFilters) => {
    setFiltrosUI(newUiFilters);
    setPaginaAtual(1);
    setFilterLoading(true);
    fetchData(1, quantidadePorPagina, newUiFilters);
  }, [fetchData, quantidadePorPagina]);

  const handleLimparFiltros = useCallback(() => {
    const cleared = {
      search: '',
      IdVaga: '',
      TituloVaga: '',
      Nome: '',
      Sobrenome: '',
      CPF: '',
      Email: '',
      NumeroTelefone: '',
      Escolaridade: '',
      EstadoLocalizacao: '',
      CidadeLocalizacao: '',
      BairroLocalizacao: '',
      RuaLocalizacao: '',
      CEPLocalizacao: '',
      NumeroLocalizacao: '',
      somenteComCNH: '',
      NumeroCNH: '',
      CategoriaCNH: '',
      validadeCnhInicio: '',
      validadeCnhFim: '',
      somenteComCurriculo: '',
      dataCriadoInicio: '',
      dataCriadoFim: '',
      PIS: '',
      incluirDeletados: '',
      sortBy: '',
      sortDir: '',
    };
    setFiltrosUI(cleared);
    setPaginaAtual(1);
    setFilterLoading(true);
    fetchData(1, quantidadePorPagina, cleared);
  }, [fetchData, quantidadePorPagina]);

  return {
    data,
    loading,
    filterLoading,
    totalRegistros,
    paginaAtual,
    quantidadePorPagina,
    filtrosUI,
    handleFilterApply,
    handleLimparFiltros,
    setPaginaAtual,
    setQuantidadePorPagina,
    refetch: () => fetchData(paginaAtual, quantidadePorPagina, filtrosUI),
  };
};
